<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col>
          <v-card>
            <v-card-text>
              <div class="d-flex justify-space-between">
                
                <div>
                  <v-chip-group column>
                    <v-chip small v-if="hasValue(getRetentionConfigs.queryParams.status__in)"><b class="mr-1">Status:</b>{{getRetentionConfigs.queryParams.status__in.join(', ')}}</v-chip>
                    <v-chip small v-if="hasValue(getRetentionConfigs.queryParams.agent_sid)"><b class="mr-1">Agent:</b>{{getRetentionConfigs.queryParams.agent_sid}}</v-chip>
                    <v-chip small v-if="getRetentionConfigs.queryParams.creation_timestamp__gte && getRetentionConfigs.queryParams.creation_timestamp__lte"><b class="mr-1">Created:</b>{{ getRetentionConfigs.queryParams.creation_timestamp__gte | formatDateWithoutTime }} to {{ getRetentionConfigs.queryParams.creation_timestamp__lte | formatDateWithoutTime }}</v-chip>
                    <v-chip small v-if="getRetentionConfigs.queryParams.closed_timestamp__gte && getRetentionConfigs.queryParams.closed_timestamp__lte"><b class="mr-1">Closed:</b>{{ getRetentionConfigs.queryParams.closed_timestamp__gte | formatDateWithoutTime }} to {{ getRetentionConfigs.queryParams.closed_timestamp__lte | formatDateWithoutTime }}</v-chip>
                    <v-chip small v-if="getRetentionConfigs.queryParams.transfers"><b class="mr-1">Transfers:</b><span class="text-capitalize">{{getRetentionConfigs.queryParams.transfers}}</span></v-chip>
                    <v-chip small v-if="productFilter.length>0"><b class="mr-1">Product Kind:</b><span>{{ productFilter.join(', ') }}</span></v-chip>
                    <v-chip small v-if="getRetentionConfigs.queryParams.no_contact"><b class="mr-1">No Contact</b></v-chip>
                  </v-chip-group>
                </div>

                <template v-if="hasUserGotRoles(['can-export-retention-leads-for-dialler'])">
                  <div>
                    <v-btn color="secondary" small @click="confirmExport" :disabled="downloading" :loading="downloading">
                      <v-icon small class="mr-2">download</v-icon>
                      Dialler Export
                    </v-btn>
                  </div>
                </template>
              </div>

              <v-data-table mobile-breakpoint="960" :headers="headers" :items="getRetentionLeads" @click:row="rowClickListener" :loading="retentionLeadsLoading" :server-items-length="getRetentionConfigs.paginationCount" :options.sync="options.pagination" :footer-props="{itemsPerPageOptions: itemsPerPageOptions}">
                <template v-slot:item.id="{ item }"><span class="body--text">{{ item.id }}</span></template>
                <template v-slot:item.account_id="{ item }"><span class="body--text">{{ item.account_id }}</span></template>
                <template v-slot:item.billing_account_business_name="{ item }"><span class="body--text">{{ item.billing_account_business_name }}</span></template>
                <template v-slot:item.creation_timestamp="{ item }"><span class="body--text" style="white-space:nowrap;">{{ item.creation_timestamp | formatDate }}</span></template>
                <template v-slot:item.status="{ item }"><span class="body--text">{{ item.status }}</span></template>
                <template v-slot:item.no_contact="{ item }"><v-icon color="body">{{ item.no_contact | getNCIcon }}</v-icon></template>
                <template v-slot:item.agent_sid="{ item }"><span class="body--text">{{ findAgentById(item.agent_sid) }}</span></template>
                <template v-slot:item.is_transfer="{ item }"><v-icon color="body">{{ item.is_transfer | getIcon }}</v-icon></template>
                <template v-slot:item.contains_voip="{ item }"><v-icon color="body">{{ item.contains_voip | getIcon }}</v-icon></template>
                <template v-slot:item.contains_telco="{ item }"><v-icon color="body">{{ item.contains_telco | getIcon }}</v-icon></template>
                <template v-slot:item.cease_or_transfer_date="{ item }"><span class="body--text" style="white-space:nowrap;">{{ item.cease_or_transfer_date | formatDate(" ") }}</span></template>
                <template v-slot:item.saved_leads="{ item }"><span class="body--text">{{ item.saved_leads }}</span></template>
                <template v-slot:item.closed_timestamp="{ item }"><span class="body--text" style="white-space:nowrap;">{{ item.closed_timestamp | formatDate(" ") }}</span></template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <RententionLeadFilter :openFilter="openFilter" :agents="listOfAgents" @closeDialog="$emit('closeDialog')"/>
  </div>
</template>

<script>
import RententionLeadFilter from "./RetentionLeadTableFilter";

import { mapState, mapActions, mapGetters } from "vuex";

export default {
  components: {
    RententionLeadFilter
  },

  props: {
    openFilter: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      options: {
        pagination: {
          page: 1,
          itemsPerPage: 50,
          sortBy: [],
          sortDesc: [],
        },
        queryParams: {
          status__in: ["New","Open"],
          transfers: "include",
          contains_voip: false,
          contains_telco: false,
          contains_websites: false,
        },
      },

      itemsPerPageOptions: [10, 25, 50],

      headers: [
        {text: "ID", align: "start", sortable: false, value: "id"},
        {text: "Account ID", sortable: false, value: "account_id"},
        {text: "Business Name", sortable: false, value: "billing_account_business_name"},
        {text: "Created", sortable: true, value: "creation_timestamp", width: "100px"},
        {text: "Status", sortable: false, value: "status", width: "90px"},
        {text: "No Contact", sortable: false, value: "no_contact", width: "90px"},
        {text: "Agent", sortable: false, value: "agent_sid"},
        {text: "Contains Transfers", sortable: false, value: "is_transfer"},
        {text: "Contains VoIP", sortable: false, value: "contains_voip"},
        {text: "Contains Telco", sortable: false, value: "contains_telco"},
        {text: "Transfer Date", sortable: true, value: "transfer_out_date"},
        {text: "Contract End Date", sortable: true, value: "contract_end_date"},
        {text: "Saved", sortable: false, value: "saved_leads.display_format"},
        {text: "Closed", sortable: false, value: "closed_timestamp"}
      ],
      
      listOfAgents: [],
      listOfAgentsNamed: {},
      downloading: false,
    };
  },

  filters: {
    formatDate: (val, text) => {
      if (!val) return text || "No Information";
      return val.split("T")[0];
    },

    formatBoolean: val => {
      if (!val) return "No Information";
      return val ? "Yes" : "No";
    },

    getIcon: val => {
      if (val === null || val === "") return "";
      return val ? "check" : "close";
    },

    getNCIcon: val => {
      return (val===true) ? "check" : "close";
    }
  },

  computed: {
    ...mapState("retention", ["retentionAgents","retentionLeadsLoading"]),
    ...mapGetters("retention", ["getRetentionLeads", "getRetentionConfigs"]),
    ...mapGetters("globals", ["hasUserGotRoles"]),

    productFilter() {
      const products = [];

      this.getRetentionConfigs.queryParams.contains_voip && products.push('VoIP');
      this.getRetentionConfigs.queryParams.contains_telco && products.push('Telco');
      this.getRetentionConfigs.queryParams.contains_websites && products.push('Websites');

      return products;
    },

    getSort() {
      return this.options.pagination.sortBy[0] || "";
    },

    getOrder() {
      if(this.options.pagination.sortDesc.length && this.options.pagination.sortDesc[0] === true) return "desc";
      if(this.options.pagination.sortDesc.length && this.options.pagination.sortDesc[0] === false) return "asc";
      return '';
    },

    hasValue() {
      return (val) => val && val.length;
    }
  },

  watch: {
    "options.pagination": {
      immediate: false,
      handler () {
        const query = { 
          pagination: {
            page: this.options.pagination.page,
            limit: this.options.pagination.itemsPerPage,
            sort: this.getSort,
            order: this.getOrder,
          },
          queryParams: { ...this.options.queryParams },
        };

        this.updateRetentionPagination(query);
      
        if(this.options.queryParams) {
          delete this.options.queryParams;
        }
      },
      deep: true,
    },
  },

  methods: {
    ...mapActions("retention", ["getRetentionAgents", "loadRetentionLeads", "updateRetentionPagination","downloadExportByFilter"]),

    async confirmExport(){
      if(confirm('Continue downloading the dialler export?')){
        this.downloading = true;
        let download = await this.downloadExportByFilter();
        if(download){
          const blob = new Blob([download], { type: "text/tsv" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = 'Dialler Export.tsv';
          link.click();
          URL.revokeObjectURL(link.href);
        }
        this.downloading = false;
      }
    },

    showAgentsChp(agents) {
      let loAgents = [];
      agents.forEach(ag=>{
        loAgents.push(this.findAgentById(ag));
      });
      return loAgents.join(', ');
    },

    findAgentById(agent) {
      return this.listOfAgentsNamed[agent];
    },

    rowClickListener(e) {
      this.$router.push({
        name: "retentionleadview",
        params: { acc_id: e.account_id, id: e.id },
      });
    },
  },

  mounted () {
    const queryParams = JSON.parse(JSON.stringify(this.$route.query));

    if(queryParams && Object.keys(queryParams).length) {
      this.options.pagination.page = parseInt(queryParams.page);
      this.options.pagination.itemsPerPage = parseInt(queryParams.limit);
      this.options.pagination.sortBy = queryParams.sort ? [queryParams.sort] : [];
      this.options.pagination.sortDesc = queryParams.order === 'asc' ? [false] : queryParams.order === 'desc' ? [true] : [true];
      this.options.queryParams = { ...queryParams };
    } else {
      this.options.page = 1;
      this.options.pagination.itemsPerPage = 50;
      this.options.pagination.sortBy = ["last_changed"];
      this.options.pagination.sortDesc = [true];
      this.options.queryParams.status__in = ["New", "Open"];
    }

    this.getRetentionAgents().then(()=>{
      let agents = [];
      let agentsNamed = {};
      this.retentionAgents.forEach(v=>{
        agents.push({text: v.long_name,value: v.sid});
        agentsNamed[v.sid] = v.long_name;
      });
      this.listOfAgents = agents.sort();
      this.listOfAgentsNamed = agentsNamed;
    });
  },
};
</script>

<style lang="scss" scoped>
  .v-data-table ::v-deep tbody tr {
    cursor: pointer !important;
  }
</style>
